export enum LocaleActionType {
    LOCALE_INIT = 'LOCALE_INIT'
}
